import { DecimalPipe } from '@angular/common';
import { Component, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, concat, from, map, of } from 'rxjs';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { AiCreditsService } from 'src/app/settings/services/ai-credits.service';

@Component({
  selector: 'ai-chatbot-credits-menu',
  templateUrl: './ai-chatbot-credits-menu.component.html',
  styleUrl: './ai-chatbot-credits-menu.component.scss',
  providers: [DecimalPipe],
  standalone: false,
})
export class AiChatbotCreditsMenuComponent {
  private emptyCredits = { creditsRemaining: 0, creditsTotal: 0 };
  private aiCredits = toSignal(
    concat(
      from(this.aiCreditsService.getAICredits()).pipe(
        catchError(() => of(this.emptyCredits)),
      ),
      this.aiCreditsService.creditsUsed$.pipe(
        map((credits) => ({
          creditsRemaining: credits.creditsRemaining,
          creditsTotal: credits.creditsTotal,
        })),
      ),
    ),
    { initialValue: this.emptyCredits },
  );

  protected creditsPercentage = computed(() => {
    const { creditsRemaining, creditsTotal } = this.aiCredits();
    return creditsTotal > 0 ? (creditsRemaining / creditsTotal) * 100 : 0;
  });
  protected creditsRemaining = computed(() => {
    return this.decimalPipe.transform(
      this.aiCredits().creditsRemaining,
      '1.0-0',
    );
  });
  protected creditsTotal = computed(() => {
    return this.decimalPipe.transform(this.aiCredits().creditsTotal, '1.0-0');
  });
  protected companyName = computed(() => {
    return this.companyStateService.getSelectedCompanyName();
  });

  constructor(
    private aiCreditsService: AiCreditsService,
    private companyStateService: CompanyStateService,
    private decimalPipe: DecimalPipe,
  ) {}

  protected openCreditsModal() {
    this.aiCreditsService.openCreditsModal();
  }
}
